<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-2">
    <div class="flex gap-4">
      <input
        iInput
        size="sm"
        class="flex-1"
        type="text"
        placeholder="{{ t('sp-strategy-group-page.search_by_segment_name') }}"
        [(ngModel)]="tacticSearchInput"
      />
      <button iButton [disabled]="modalData.isReadOnly" (click)="createTactic()">
        <IIcon name="add" />
        {{ t("sp-strategy-group-page.new_tactic_label") }}
      </button>
    </div>
    <div class="flex flex-1 flex-col gap-4 overflow-y-auto">
      @for (t of filteredTactics(); track t) {
        <div class="flex gap-2">
          <app-tactic
            class="w-full"
            [showKW]="true"
            [showProducts]="!disableProductSegment || t.tacticType === 'BLACKLIST'"
            [tactic]="t"
            [strategy]="modalData.strategy"
            [isReadOnly]="modalData.isReadOnly"
            (tacticDeleted)="tacticDeleted(t)"
          />
        </div>
      } @empty {
        @if (tactics().length > 0) {
          <div class="flex h-full items-center justify-center">
            <IEmptyState
              [title]="
                t('sp-strategy-group-page.no_tactic_label', { tactic: modalData.tacticType === TacticType.BLACKLIST })
              "
              [description]="t('strategy-page.no_tactic_description', { tactic: tacticSearchInput() })"
            />
          </div>
        }
      }
      @if (tactics().length === 0) {
        <div class="flex h-full items-center justify-center">
          <IEmptyState
            [title]="
              t('sp-strategy-group-page.no_tactic_label', { tactic: modalData.tacticType === TacticType.BLACKLIST })
            "
          />
        </div>
      }
    </div>
  </div>
</ng-container>
